import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
import { Accordion, Badge, Checkbox } from "@components/v2";
import { type SalesTableReportV3BreakdownsFilterInput } from "@north-beam/nb-client-side";

interface Props {
  selection: SalesTableReportV3BreakdownsFilterInput[];
  onChange: (val: SalesTableReportV3BreakdownsFilterInput[]) => void;
}

export const Filters = ({ selection, onChange }: Props) => {
  const { value: breakdowns } = useSalesBreakdownConfigs();

  return (
    <div className="flex flex-col overflow-hidden">
      <div className="text-xs font-semibold mb-2">Filters</div>
      <div className="overflow-auto pr-2">
        {breakdowns.map((breakdown) => {
          const selectionLength = selection.filter(
            (e) => e.breakdown === breakdown.key,
          ).length;

          return (
            <Accordion
              key={breakdown.name}
              title={breakdown.name}
              rightSideContent={(isExpanded) => (
                <div className="flex items-center gap-3">
                  {isExpanded && (
                    <button
                      className="text-2xs text-v2-action underline"
                      onClick={(e) => {
                        e.stopPropagation();

                        const selectedItems = selection.map(
                          (e) => `${e.breakdown}${e.value}`,
                        );
                        console.log(selectedItems);

                        onChange([
                          ...selection,
                          ...breakdown.choices
                            .filter(
                              (e) =>
                                !selectedItems.includes(
                                  `${breakdown.key}${e.value}`,
                                ),
                            )
                            .map((e) => ({
                              breakdown: breakdown.key,
                              value: e.value,
                            })),
                        ]);
                      }}
                    >
                      Select All
                    </button>
                  )}
                  <Badge variant="information">{selectionLength}</Badge>
                </div>
              )}
            >
              <div className="grid grid-cols-[290px_290px_290px] py-2">
                {breakdown.choices.map((label) => {
                  const isChecked =
                    selection.find(
                      (e) =>
                        e.breakdown === breakdown.key &&
                        e.value === label.value,
                    ) !== undefined;

                  return (
                    <div key={label.value} className="py-[1px]">
                      <Checkbox
                        size="sm"
                        label={label.label}
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            onChange([
                              ...selection,
                              { breakdown: breakdown.key, value: label.value },
                            ]);
                          } else {
                            onChange(
                              selection.filter(
                                (e) =>
                                  !(
                                    e.breakdown === breakdown.key &&
                                    e.value === label.value
                                  ),
                              ),
                            );
                          }
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
